import addToCartReducer from "../redux/addToCart/addToCartReducer";

const stockChecker = (store) => (next) => (action) =>{
    console.log(`Action: ${JSON.stringify(action)}`);
    console.log(`Before: ${JSON.stringify(store.getState())}`);

    const upcommingState = [action].reduce(addToCartReducer, store.getState());


    console.log(`Upcomming: ${JSON.stringify(upcommingState.products)}`);
    //pass action
    upcommingState.products.map((item) => {
      if(item.id === action.payload.id){
        if(item.quantity >= 0 ) {
            return next(action);
        }
      }
    })

    upcommingState.cart.map((item) => {
        if(item.id === action.payload){
          if(item.qty >= 0 && item.qty <= item.quantity) {
              return next(action);
          }
        }
      })
   
} 

export default stockChecker;